/**
 * Index Controller
 */
/*
  globals moment
*/
(function(angular) {
    'use strict';

    var app = angular.module('asSecureCommerce');

    app.controller('SitesIndexController', [
        '$scope',
        '$window',
        '$timeout',    
        'seApi',
        function($scope, $window, $timeout, seApi) {
            $scope.site_id = '';
            
            $scope.deleteSite = function(site_id) {                                                                                 
                $scope.site_id = site_id;
                
                showModalDialog('Please confirm that you are going to delete site '+ $scope.site_id +' (can not be undone)', function() {
                    $('#loader').parent().show();
                    $('#loader').show();
                    
                    seApi.delete("sites", JSON.stringify({site_id: $scope.site_id})).then(
                        function(data) {                            
                            $window.location.href = '/#!/se/sites';
                            $.alert('success', 'message' in data ? data.message : 'Site was successfully deleted', true);
                            $('#loader').parent().hide();
                            $('#loader').hide();
                            $window.setTimeout(function() {$window.location.reload();}, 1500);                          
                        },
                        function(data) {                            
                            $window.location.href = '/#!/se/sites';
                            let error = 'message' in data ? ': '+data.message : '';
                            $.alert('error', 'Error occured'+error, true);
                            $('#loader').parent().hide();
                            $('#loader').hide();
                        }
                    );
                });                 
            };
        },
    ]);
})(window.angular);
